import axios from "axios";
import config from "../../../config";

const baseUrl = config.baseUrl;
const endpoint = "/api/financiero/fin_bodegas";

const getBodegas = async () => {
  const response = await axios.get(`${baseUrl}${endpoint}`);
  return response.data;
};

const createBodega = async (data, usuario) => {
  const response = await axios.post(
    `${baseUrl}${endpoint}`,
    data,
    {
      headers: {
        usuario: usuario
      }
    }
  );
  return response.data;
};

const updateBodega = async (id, data, usuario) => {
  const response = await axios.put(
    `${baseUrl}${endpoint}/${id}`,
    data,
    {
      headers: {
        usuario: usuario
      }
    }
  );
  return response.data;
};

const deleteBodega = async (id, usuario) => {
  const response = await axios.delete(
    `${baseUrl}${endpoint}/${id}`,
    {
      headers: {
        usuario: usuario
      }
    }
  );
  return response.data;
};

export {
  getBodegas,
  createBodega,
  updateBodega,
  deleteBodega
};
